import { em, math } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'

const tubeWidth = em(200)
const tubeWidthMd = em(380)

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: ${tubeWidth};

  ${p => p.theme.mq.upMd} {
    height: ${tubeWidthMd};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  position: absolute;
  left: 50%;
  bottom: 0;
  //max-width: 100%;
  width: ${tubeWidth};
  height: auto;
  transform-origin: 0 100%;
  transform: translateX(70%) rotate(-90deg);

  ${p => p.theme.mq.upMd} {
    left: 50%;
    width: auto;
    height: 140%;
    transform: translate(-50%, 20%);
  }

  ${p => p.theme.mq.upLg} {
    height: 150%;
    transform: translate(-50%, 14%);
  }
`

export const LineImg = styled.img`
  display: none;
  position: absolute;
  left: 50%;
  top: 81%;
  width: ${em(187)};
  transform: translate(-50%, -100%);
  margin-left: ${math(`${em(-187)} * 1.17`)};

  ${p => p.theme.mq.upLg} {
    display: block;
  }
`
